/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_DemotedInputs */

const cs_property_ai_demoted = /** @type {(inputs: Property_Ai_DemotedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přesunuto do AI návrhů`)
};

const en_property_ai_demoted = /** @type {(inputs: Property_Ai_DemotedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moved to AI drafts`)
};

/**
* | output |
* | --- |
* | "Moved to AI drafts" |
*
* @param {Property_Ai_DemotedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_demoted = /** @type {((inputs?: Property_Ai_DemotedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_DemotedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_demoted(inputs)
	return cs_property_ai_demoted(inputs)
});